import { setUserProperties } from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { UPSELL_PAGE_DISMISSED_PROPERTY_KEY } from '../../constants.tsx';
import type { CmdbUpsellPageStoreAction } from '../../types.tsx';

export const dismissPage =
	(): CmdbUpsellPageStoreAction =>
	async ({ setState }, { atlassianAccountId }) => {
		// Optimistically hide Assets from the navigation bar immediately
		setState({ userHasDismissed: true });

		try {
			// The specific value being set doesn't matter as long as the property *has* been set
			atlassianAccountId &&
				(await setUserProperties(atlassianAccountId, UPSELL_PAGE_DISMISSED_PROPERTY_KEY, '1'));
		} catch (error) {
			// When setting the user property fails, we still want to hide Assets from the navigation bar
			fireErrorAnalytics({
				error: error instanceof Error ? error : undefined,
				meta: {
					id: 'fetchUpsellDismissedProperty',
					packageName: 'jiraCmdbUpsellPage',
				},
			});
		}
	};
